import request from '@/router/axios';
export const getCarInfo = (row) => {
    return request({
        url: '/api/produce/transport-plan/planSummary',
        method: 'post',
        data: row
    })
}
export const getInfo = (row) => {
    return request({
        url: '/api/produce/transport-plan/planSummaryDetail',
        method: 'post',
        data: row
    })
}
